import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  FeatureFlagAdminItemSchema,
  UpdateFeatureFlagBodySchema,
} from '../schemas/feature-flags.js';

export const featureFlagsAdmin = {
  /** GET /admin/feature-flags — list all feature flags (admin-only). */
  list: endpoint('GET', '/admin/feature-flags', z.object({}), z.array(FeatureFlagAdminItemSchema)),

  /** PATCH /admin/feature-flags/:key — toggle a feature flag's enabled state (admin-only). */
  update: endpoint(
    'PATCH',
    '/admin/feature-flags/:key',
    z.object({ key: z.string() }).merge(UpdateFeatureFlagBodySchema),
    FeatureFlagAdminItemSchema,
  ),
};
